import AdditionalInfoDetail from "@/components/Details/AdditionalInfoDetail";
import ContractInfoDetail from "@/components/Details/ContractInfoDetail";
import PersonalInfoDetail from "@/components/Details/PersonalInfoDetail"
import PositionInfoDetail from "@/components/Details/PositionInfoDetail";

const RoleInfoTab = (props: any): JSX.Element => {
    const {detail} = props;
    return (
        <>
            <PositionInfoDetail detail={detail}/>
            <ContractInfoDetail detail={detail}/>
        </>
    )
}

export default RoleInfoTab;